import clsx from "clsx";

import styles from "./organization-structure-hero.module.css";

const HERO_ILLUSTRATION = "/assets/images/organization_structure_icon.jpg";

export interface OrganizationStructureHeroProps {
  title?: string;
  description?: string;
}

export function OrganizationStructureHero({
  title = "Organization Management",
  description = "Manage the organizational hierarchy with departments, designations, and roles.",
}: OrganizationStructureHeroProps) {
  return (
    <section
      className={styles.hero}
      aria-labelledby="organization-structure-hero-heading"
    >
      <div className={styles.row}>
        <div className={styles.copy}>
          <h1
            id="organization-structure-hero-heading"
            className={clsx("heading-lg", styles.title)}
          >
            {title}
          </h1>
          <p className={clsx("sub-heading-sm", styles.subtitle)}>
            {description}
          </p>
        </div>
        <div className={styles.art} aria-hidden>
          <img
            src={HERO_ILLUSTRATION}
            alt=""
            className={styles.heroImg}
            width={320}
            height={160}
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
}
